import { trigger, state, transition, style, animate } from '@angular/animations';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { NbDialogRef, NbStepChangeEvent, NbStepperComponent } from '@nebular/theme';
import { ITransferResources } from '@shared/interfaces/resources/transfer-resources';
import { IPrintUploadPreview } from '@shared/modules/print-file-shared/interfaces/print-upload-preview';

@Component({
  selector: 'app-multiprint',
  templateUrl: './multiprint.component.html',
  styleUrls: ['./multiprint.component.scss'],
  animations: [
    trigger('enterTrigger', [
      state('fadeIn', style({
        opacity: '1',
        transform: 'translateY(50%)'
      })),
      transition('void => *', [style({
        opacity: '0',
        transform: ''
      }), animate('500ms')])
    ])
  ]
})
export class MultiprintComponent implements OnInit {
  @ViewChild("stepper") stepper!: NbStepperComponent;
  
  @Input() modalTitle: string = 'bulk.bulk-print';
  @Input() transferResources!: ITransferResources;
  @Input() onlyDeviceIds: string[] = [];
  @Input() disableFirstStep: boolean = false;

  currentStep: number = 1;
  dataFromStepOne!: IPrintUploadPreview;

  firstStepForm = this.fb.group({
    valid: [false, Validators.requiredTrue],
  });

  secondStepForm = this.fb.group({
    valid: [false, Validators.requiredTrue],
  });

  thirdStepForm = this.fb.group({
    valid: [false, Validators.requiredTrue],
  });

  constructor( protected dialogRef: NbDialogRef<MultiprintComponent>, private fb: UntypedFormBuilder) { }

  ngOnInit(): void {

  }

  cancel(): void {
    this.dialogRef.close();
  }

  onFinishFirstStep(uploadData: IPrintUploadPreview) {
    this.firstStepForm.controls['valid'].setValue(true);
    this.secondStepForm.controls['valid'].setValue(false);
    this.thirdStepForm.controls['valid'].setValue(false);

    this.dataFromStepOne = uploadData;
    this.stepper.next();
    this.currentStep = 2;
  }

  onFinishSecondStep() {
    this.secondStepForm.controls['valid'].setValue(true);
    this.stepper.next();
    this.currentStep = 3;
  }

  onFinishThirdStep(){
    this.stepper.disableStepNavigation = true;
  }

  goBackStep() {
    this.stepper.previous();
  }

  handleStepChange(e: NbStepChangeEvent): void {
    this.currentStep = e.index + 1;
  }
}